import { render, staticRenderFns } from "./RefuseModal.vue?vue&type=template&id=0afbb2e8"
import script from "./RefuseModal.vue?vue&type=script&lang=js"
export * from "./RefuseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports